import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import "./SuccessModal.scss";
import StatusIcon from "../../../img/correct.png";
import Image from "react-bootstrap/Image";
import useTranslationCommon from "../useTranslationCommon.js";
import useShowLoader from "../loading-widgets/useShowLoader.js";
import StringUtils from "../../../utils/StringUtils.js";

/**
 * Display a success modal. Content is passed as a child. onDismiss is called when user dismisses the modal.
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
export default function SuccessModal({show, onDismiss, children, className}) {

  const {t, loading: tLoading} = useTranslationCommon();
  useShowLoader(tLoading, "SuccessModal");

  // RENDER

  return (
    <Modal show={show} onHide={onDismiss} className={`SuccessModal ${StringUtils.isNullOrEmpty(className) ? "" : className}`}>
      <Modal.Body>
        <div>
          <Image src={StatusIcon} className={"status-icon"}/>
        </div>
        <div>
          {children ? children : null}
        </div>
        <div className={"button-row"}>
          <Button onClick={onDismiss}>
            {t("common:close_button")}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
